// extracted by mini-css-extract-plugin
export default {"mochi-checkbox":"mochi-checkbox_mochi-checkbox__rWWf7"};